import AdvertorialAdSpot from './adSpot/AdvertorialAdSpot';
import AdvertorialDevTools from './rui-advertorial-devtools';
import { log, logError } from './utils/loggingUtil';
import { track } from './tracking';
import { withAdLoadStartedEvent } from './tracking/events';
import requestAd from './generator/requestAd';
import renderAdGenerator from './generator/renderAd';
import generateJavaScriptAd from './generator/generateJavaScriptAd';
import FetchError from './utils/customErrorType';
export var generateCreateAd = function generateCreateAd(Advertorial) {
  return function (options) {
    var adSpot = new AdvertorialAdSpot(options);

    if (AdvertorialDevTools.isDisabled(adSpot)) {
      log('AdSpot disabled by AdvertorialDevTools', adSpot);
      return;
    }

    track(withAdLoadStartedEvent(), adSpot);
    adSpot.reset();

    if (Advertorial) {
      var adSpotWithDebugging = AdvertorialDevTools.addDebuggingParams(adSpot);
      Advertorial.allAds.push(adSpotWithDebugging);
    }

    var generateAdPromise = adSpot.config.type === 'native' ? requestAd(adSpot).then(renderAdGenerator(adSpot)) : generateJavaScriptAd(adSpot.getLink(), adSpot.element, adSpot.loadCompleteCallback);
    generateAdPromise.then(function (msg) {
      log('Loaded Ad Success:', msg);
    })["catch"](function (err) {
      if (typeof adSpot.loadCompleteCallback === 'function') {
        adSpot.loadCompleteCallback(undefined, false);
      }

      logError('Loaded Ad Error', err);

      if (!(err instanceof FetchError)) {
        var _adSpot$logError;

        (_adSpot$logError = adSpot.logError) === null || _adSpot$logError === void 0 ? void 0 : _adSpot$logError.call(adSpot, 'Ad load error', err);
      }
    });
  };
};
var createAd = generateCreateAd();
export default createAd;
//# sourceMappingURL=createAd.js.map